import React,{Component} from 'react';
import classnames from "classnames";
import { connect } from 'react-redux';
import {addCategory,onDismiss,getCategories} from '../../../actions/categoryActions';
import {
    TabContent,
    Row,
    Col,
    Input,
    TabPane,
    Nav,
    NavItem,
    NavLink
  } from "reactstrap";
  import { Button } from '../../../components';
  import FeaturedImage from "../../../components/imageUpload/FeatureImage";
  import Select from "react-select";
  import SweetAlert from 'sweetalert2-react';
  import SimpleReactValidator from 'simple-react-validator';
  
class AddCategory extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.onDismissPopup = this.onDismissPopup.bind(this);
        this.state = {
          activeTab: "1",
          selectedOption: null,
          name:'',
          code:'',
          isMounted: false,
          image:'',
          note:'',
          parent_id:'',
          tags:[],
          categories:[],
          selectedCateory: null,
          selectedTag: []
        };
        this._onImageChange = this._onImageChange.bind(this);
        this.validator = new SimpleReactValidator();
      }
      toggle(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

      componentDidMount() {
        this.setState({ isMounted: true }, () => {
          if (this.state.isMounted) {
         this.setState({ isMounted: false });
        this.props.onGetCategories();
      }
      });
      }
      onDismissPopup(){
        this.props.onDismiss();
      }
      handleTag  = (selectedTag) => {
        this.setState({ selectedTag });
      }
      handleCat = (selectedCateory) => {
        if(selectedCateory.index !== 0 ){
          this.setState({ selectedCateory });
        }else{
          this.setState({ selectedCateory:null });
        }
      };

      _onImageChange(image){
        this.setState({
          image
        })
      }
      handleSubmit = (e) => {
        e.preventDefault();
        var data = {
          code: this.state.code,
          name: this.state.name,
          note:this.state.note,
          featured_image: this.state.image
        };
      
        if(this.state.selectedTag.length > 0){
         
          var obj = this.state.selectedTag.map((item,index)=>{
            return { tag: item.value };
          });
          data['tags'] = obj;
        }

        if(this.state.selectedCateory ){
          data['parent_id'] =  this.state.selectedCateory.value;
        }
        if( this.validator.allValid() ){
         this.props.onAddCategory(data);
        }
        else {
          this.validator.showMessages();
          this.forceUpdate();
        }
    
      }
      componentWillReceiveProps(nextProps) {
        if (nextProps.status === true) {
          this.setState({
            name:'',
            code:'',
            image:'',
            note:'',
            selectedCateory: null,
            selectedTag: []
           });
        }
    }
        //loader
        getLoder() {
          let classes = "bt-loader ";
          classes += this.props.loading ? 'bt-show' : 'bt-hide';
          return classes;
        }
    render() { 
      const { selectedCateory } = this.state;
      const { selectedTag } = this.state;

    
    let catOptions = this.props.categories.map(function(category,ind) {
      return { value: category.id, label: category.name, index:ind+1 };
    });
    catOptions.unshift({ value: "None", label: "None" , index:0});
        return ( 
            <div>
          <div className="content">
          <div className={this.getLoder()}></div>
            <div className="form-section">  
            <div className="bottom-nav">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1"
                    })}
                    onClick={() => {
                      this.toggle("1");
                    }}
                  >
                    Info
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="form-filds-wrapper">
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <div className="flex-wrapper">
                          <FeaturedImage imageReset={this.state.image} onImageChange={(image)=>this._onImageChange(image)}>Category Image</FeaturedImage>
                          <div className="errorMsg">{this.validator.message('image', this.state.image, 'required')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="control-label">Category Name</label>
                        <input type="text" className="form-control" value={this.state.name}  onChange = {(e)=> this.setState({name:e.target.value})}/>
                        <div className="errorMsg">{this.validator.message('name', this.state.name, 'required')}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="control-label">Category Code</label>
                        <input type="text" className="form-control" value={this.state.code} onChange = {(e)=> this.setState({code:e.target.value})}/>
                        <div className="errorMsg">{this.validator.message('code', this.state.code, 'required')}</div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                    <div className="form-group">
                        <label className="control-label">Notes</label>
                        <Input type="textarea" name="text" value={this.state.note} placeholder="Type Here ..." onChange = {(e)=> this.setState({note:e.target.value})}/>
                      </div>
                    </div>
                  </div>
                  <Row>
                  <Col md="4">
                    <div className="form-group">
                    <label className="control-label">Parent Category</label>
                        <Select onChange ={this.handleCat} value={selectedCateory} options={catOptions}  />
                      </div>
                      </Col>
                    </Row>
                  <Row>
                      <Col md="12">
                      <div className="submit-wrapper">
                      <Button className="btn-submit" >Save</Button>
                      </div>
                      </Col>
                  </Row>
                  </form>
                </div>
                <SweetAlert
                  show={this.props.status && this.props.popup}
                  title="Success"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />
                  <SweetAlert
                  show={ !this.props.status && this.props.popup}
                  title="Error"
                  type="error"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />
              
              </TabPane>
            </TabContent>
            </div>
          </div>
        </div>
         );
    }
}
 


const mapStateToProps = (state) => ({
  loading: state.categoryReducer.loading,
  status:state.categoryReducer.status,
  categories: state.categoryReducer.categories,
  message:state.categoryReducer.message,
  popup:state.categoryReducer.popup,
  tags: state.tagReducer.tags
})

const mapDispatchToProps = (dispatch)=> ({
  onAddCategory:(data)=>{
    dispatch(addCategory(data))
  },
  onGetCategories:()=>{
    dispatch(getCategories())
  },
  onDismiss:()=>{
    dispatch(onDismiss())
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(AddCategory)
